// extracted by mini-css-extract-plugin
var _1 = "themeDark";
var _2 = "themeLight";
export { _1 as "themeDarkClassName", _2 as "themeLightClassName" }
